import React from "react";
import { DurationInputProps } from "../types";
import {
  DurationInputContainer,
  DurationInputContent,
  DurationInputField,
  DurationInputLabel,
  DurationInputPlaceholder,
} from "../styles";

// Extract validation logic for testing
export const validateDurationInput = (inputValue: string): boolean => {
  // Only accept numbers
  if (!/^\d*$/.test(inputValue)) {
    return false;
  }

  const numericValue = Number(inputValue);
  return (
    inputValue === "" ||
    (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 999)
  );
};

export const DurationInput: React.FC<DurationInputProps> = ({
  value,
  onChange,
  onEnterPress,
  disabled = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      const inputValue = e.target.value;
      if (validateDurationInput(inputValue)) {
        onChange(inputValue);
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!disabled && e.key === "Enter" && onEnterPress) {
      onEnterPress();
    }
  };

  return (
    <DurationInputContainer>
      <DurationInputContent>
        {disabled ? (
          <DurationInputField
            type="text"
            placeholder="0"
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            inputMode="numeric"
            disabled={disabled}
            style={{ opacity: 0.5, backgroundColor: "#f5f5f5" }}
          />
        ) : (
          <>
            <DurationInputPlaceholder>
              <DurationInputLabel>Duration</DurationInputLabel>
            </DurationInputPlaceholder>
            <DurationInputField
              type="text"
              placeholder="0"
              value={value}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              inputMode="numeric"
              disabled={disabled}
            />
          </>
        )}
      </DurationInputContent>
    </DurationInputContainer>
  );
};
